<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">add story</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New commercial story
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row justify="center">
                            <v-col cols="12">
                                <v-textarea dense counter rows="2" outlined auto-grow v-model="text" color="secondary"
                                    @change="onceMore()" :rules="[rules.required]">
                                </v-textarea>
                            </v-col>
                            <!--segments-->
                        </v-row>
                        <v-row v-for="(item, index) in segments" :key="item.id" justify="center" no-gutters>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="secondary" 
                                :label="`${item.segment?.name} id=${item.segmentId}`" 
                                :name="item.name" type="text"
                                readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" class="ml-4">
                                <v-text-field dense color="secondary" 
                                    label="weight" v-model.number="weights[index]" type="text"
                                    :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
                <v-row justify="center" class="text-pre-wrap subtitle-2">
                    {{ message }}
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="addStory">Save
                </v-btn>

                <v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'AddCommercialStory',
    props: ['set', 'round'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            message: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
            },
            //props
            weights: [],
            text: '',
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        segments() {
            return this.$store.getters.market_segments;
        },
    },
    methods: {
        onceMore() {
            this.error = ''
            this.message = '';
        },
        async addStory() {

            if (this.$refs.form.validate()) {
                const segments_arr = this.segments.map(seg => seg.segmentId)
                const names = this.segments.map(seg => seg.segment?.name)
                const category = this.set.item.split('_')[0];
                const story = {
                    segments: segments_arr,
                    names: names,
                    weights: this.weights,
                    category: category,
                    text: this.text
                }
                 /*console.log(story);*/
                try {
                    //add commercial story
                    await this.$store.dispatch('addCommercialStory', story)
                    this.closeDialog()
                }
                catch (error) {
                    this.error = `${error.message}`;
                    this.message = '';
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.message = '';
            this.$refs.form.reset();
        }
    },
    async mounted() {

        if (this.segments.length < 1 && this.set) {
            const gameId = Number(this.set.value);
            const round = Number(this.round);
            await this.$store.dispatch('fetchMarketSegments', {gameId, round});
        }
    }
}
</script>